/**
 * @packageDocumentation
 * @module f1/number
 */

export interface Subtract {
  /**
   * Subtract the first number from the second
   *
   * @public
   * @function f1.subtract
   * @param subtracted the number to subtract with
   * @param value the number to subtract from
   * @example
   *
   * ```ts
   * f1.subtract(2, 5) => 3
   * ```
   */
  (subtracted: number, value: number): number;
  /**
   * {@link FnSubtractValue}
   * @param subtracted the number to subtract with
   */
  (subtracted: number): (value: number) => number;
}

/**
 * @see Subtract
 */
export default (subtracted: number, value: number) => value - subtracted;
